import styled from "styled-components";
import Box from "../../../../Styled/Box";
export const CreditsContainer = styled(Box).attrs(() => ({
  styledHeight: "30px",
  styledMaxHeight: "30px",
  verticalCenter: true,
  gap: true
})).withConfig({
  displayName: "CreditsContainer",
  componentId: "sc-1uk18a2-0"
})(["a{text-decoration:underline;cursor:pointer;color:", ";display:flex;align-items:center;}img{height:24px;}"], props => props.theme.textLight);